export const isDate = (value: any): value is Date => {
  return value instanceof Date;
};

export const isString = (value: any): value is string => {
  return typeof value === 'string';
};

export const isStringArray = (x: any[]): x is string[] => {
  return x.every((i) => typeof i === 'string');
};

export const isKeyOf = <T extends object>(
  key: PropertyKey,
  obj: T
): key is keyof T => {
  return key in obj;
};

export const isBooleanString = (value: any): value is string => {
  return value === 'true' || value === 'false';
};
